export const validateFileExtension = (file: File, extention: string[] | string): boolean => {
  const fileExtension = file.name.split('.').pop()?.toLowerCase()

  return fileExtension ? extention.includes(fileExtension) : false
}
